/**
 * `/view/$publicId` — a mockup's link, opened (session 49), and since session 55 the one place a
 * mockup is reviewed. `/preview/<public_id>/` redirects here: the studio's page full-screen,
 * and the portal docked in one corner.
 *
 * Outside `/app` and `/studio`, and guarded by nothing, because the link is the whole of its
 * credential: anybody it was sent to may look and comment. A session, when there is one,
 * only changes which button the corner offers — the read says who is looking.
 */

import { createFileRoute } from '@tanstack/react-router'

import { LinkViewerPage, ReviewSearchSchema } from '../../pages/mockups/LinkViewerPage.js'
import { routeSearch } from '../../search/useSearchState.js'

export const Route = createFileRoute('/view/$publicId')({
  /** `?v=<n>` a version and `?c=<id>` a thread (session 55) — how the portal pages link into a review. */
  validateSearch: routeSearch(ReviewSearchSchema),
  component: LinkViewRoute,
})

function LinkViewRoute() {
  const { publicId } = Route.useParams()
  return <LinkViewerPage publicId={publicId} />
}
